import React, { useState } from "react";
import { FaSearch } from "react-icons/fa";
import { Pagination, Stack } from "@mui/material";
import FranchiseList from "../../components/auth/Franchise/FranchiseList";
import AddFranchiseModal from "../../components/Modals/AddFranchiseModal";

const Franchise = () => {
  const [activeTab, setActiveTab] = useState("Newly Applied");
  const [query, setQuery] = useState("");
  const [page, setPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [totalItems, setTotalItems] = useState(0);
  const [showAddModal, setShowAddModal] = useState(false);

  const itemsPerPage = 6;

  const handleTabChange = (tab) => {
    setActiveTab(tab);
    setPage(1);
    setQuery("");
  };

  const handleInputChange = (e) => {
    setQuery(e.target.value);
    setPage(1);
  };

  const handlePageChange = (event, value) => {
    setPage(value);
  };

  const handleDataChange = (pages, items) => {
    setTotalPages(pages);
    setTotalItems(items);
  };

  const handleOpenModal = () => setShowAddModal(true);
  const handleCloseModal = () => setShowAddModal(false);

  const getStatusByTab = (tab) => {
    switch (tab) {
      case "Newly Applied":
        return "Pending";
      case "Approved":
        return "Approved";
      case "Inactive":
        return "Inactive";
      default:
        return "Pending";
    }
  };

  return (
    <div>
      {/* Header Section */}
      <div className="py-12 px-6">
        <div className="flex justify-between flex-col md:flex-row">
          <h1 className="text-primaryColor text-[25px] md:text-3xl font-bold">
            Franchise
          </h1>

          <div className="flex gap-2">
            {/* Search Bar */}
            <div className="searchBar hidden md:flex relative items-center md:mt-0">
              <input
                type="text"
                placeholder="Search..."
                value={query}
                onChange={handleInputChange}
                className="pl-4 pr-10 py-2 border-2 border-primaryColor rounded-lg"
              />
              <span className="absolute w-10 h-10 right-0 rounded-r-md bg-gradient-to-r from-[#0070a8] to-[#023955] hover:from-[#1e8cbf] hover:to-[#1674a3] p-2">
                <FaSearch size={20} className="text-white" />
              </span>
            </div>

            {/* Add New Button */}
            <button
              onClick={handleOpenModal}
              className="hidden md:flex pl-4 pr-4 py-2 h-11 border-2 bg-gradient-to-r from-[#0070a8] to-[#023955] hover:from-[#1e8cbf] hover:to-[#1674a3] text-white rounded-lg"
            >
              + Add New
            </button>
          </div>
        </div>
      </div>

      {/* Tabs */}
      <div className="px-6">
        <div className="border-b tracking-wide justify-center">
          <div className="flex justify-center">
            {["Newly Applied", "Approved", "Inactive"].map((tab) => (
              <button
                key={tab}
                onClick={() => handleTabChange(tab)}
                className={`px-6 py-3 text-sm font-medium border-b-2 ${
                  activeTab === tab
                    ? "border-primaryColor text-primaryColor bg-purple-50"
                    : "border-transparent text-gray-500 hover:text-gray-700"
                }`}
              >
                {tab}
              </button>
            ))}
          </div>
        </div>
      </div>

      {/* Tab Content */}
      <div className="overflow-x-auto mt-4 px-4">
        <FranchiseList
          query={query}
          page={page}
          itemsPerPage={itemsPerPage}
          onDataChange={handleDataChange}
          status={getStatusByTab(activeTab)}
        />
      </div>

      {/* Pagination */}
      {totalPages > 1 && (
        <div className="flex justify-center my-6">
          <Stack spacing={2}>
            <Pagination
              count={totalPages}
              page={page}
              onChange={handlePageChange}
              shape="rounded"
              color="primary"
            />
          </Stack>
          <div className="ml-4 flex items-center text-sm text-gray-600">
            Showing {Math.min((page - 1) * itemsPerPage + 1, totalItems)} to{" "}
            {Math.min(page * itemsPerPage, totalItems)} of {totalItems} results
          </div>
        </div>
      )}

      {/* Add Modal */}
      {showAddModal && <AddFranchiseModal onClose={handleCloseModal} />}
    </div>
  );
};

export default Franchise;
